const noopStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

/**
 * Wrap a browser Storage object so access denials (e.g. InvalidAccessError)
 * degrade gracefully instead of crashing app flows.
 */
export function createSafeStorage(storage) {
  const target = storage || noopStorage;
  return {
    getItem: (name) => {
      try {
        return target.getItem(name);
      } catch (_) {
        return null;
      }
    },
    setItem: (name, value) => {
      try {
        target.setItem(name, value);
      } catch (_) {
        // no-op on storage write failures
      }
    },
    removeItem: (name) => {
      try {
        target.removeItem(name);
      } catch (_) {
        // no-op on storage delete failures
      }
    },
  };
}
